import API from 'services/TAPS_API';

export default function checkSign() {
  return API.request({
    method: 'GET',
    url: `/irud/status`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
